import assertString from './util/assertString';
export default function isUppercase(str) {
    assertString(str);
    return str === str.toUpperCase();
}
//# sourceMappingURL=isUppercase.js.map